import { LightTheme } from './light';
import { DarkTheme } from './dark';
// 暂不支持自定义主题
export default { light: LightTheme, dark: DarkTheme };
